import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useScrollFadeIn } from 'hooks/useScrollFadeIn';

import styled from 'styled-components';
import { isObjEmpty } from 'utils/util';

import NoImage from 'resources/common/no_image_video.png';
import { getVideoMainPortfolioList } from 'views/Portfolio/store/action';

const Portfolio = () => {
  const dispatch = useDispatch();
  const store = useSelector(state => state.portfolio);

  const [portfolioList, setPortfolioList] = useState([]);
  const [currentMethod, setCurrentMethod] = useState(); // 선택한 연출방식
  const [currentPortfolioInfo, setCurrentPortfolioInfo] = useState({}); // 선택한 연출방식의 포트폴리오

  const portfolioAnime = useScrollFadeIn({threshold: 0.3, delay: '0.1', direction: 'bottomUp'});

  const buttonList = [
    { methodType: '1', methodName: '광고' },
    { methodType: '2', methodName: '브랜드영상' },
    { methodType: '3', methodName: '3D/애니메이션' },
    { methodType: '4', methodName: '모션그래픽' },
    { methodType: '5', methodName: '스케치' },
    { methodType: '6', methodName: '유튜브콘텐츠' },
    { methodType: '7', methodName: '홍보영상' },
  ]

  /**
   * 연출방식 버튼 클릭
   * @param {string} methodNm 기법명
   */
  const clickButton = (methodNm) => {
    setCurrentMethod(methodNm);
  }

  useEffect(() => {
    const ptfoInfo = portfolioList.filter(prev => prev.mainDspClsNm === currentMethod)[0];
    setCurrentPortfolioInfo(ptfoInfo);
  }, [currentMethod]);

  useEffect(() => {
    setPortfolioList(store.mainPortfolioList);
    if (!isObjEmpty(store.mainPortfolioList)) {
      setCurrentMethod('광고');
    }
  }, [store.mainPortfolioList]);

  useEffect(() => {
    const elem = {
      videoCtgrId: `${process.env.REACT_APP_VIDEO_CATEGORY_ID}`
    }

    dispatch(getVideoMainPortfolioList(elem));
  }, []);

  return (
    <Container>
      <PortfolioContainer {...portfolioAnime}>
        <Title>포트폴리오</Title>
        <Description>브리피는 100개 이상의 기업들과 협업하며 간단한 홍보영상부터 정상급 연예인을 모델로 한<br/>광고 촬영까지 다양한 범위의 프로젝트를 수행하고 있습니다</Description>
        <MobileDescription>브리피는 100개 이상의 기업들과 협업하며 간단한 홍보영상부터 정상급 연예인을 모델로 한 광고 촬영까지 다양한 범위의 프로젝트를 수행하고 있습니다</MobileDescription>
        <PortfolioWrapper>
          <PortfolioView>
            <VideoFrame>
              { currentPortfolioInfo?.viewLnkUrl ? 
                <iframe src={`${currentPortfolioInfo.viewLnkUrl}?badge=0&autopause=0&player_id=0&autoplay=1&loop=1&muted=1`} width="600" height="340" allow="autoplay; fullscreen; picture-in-picture"></iframe>
                : <img src={NoImage} />
              }
            </VideoFrame>
            <MobileVideoFrame>
              { currentPortfolioInfo?.viewLnkUrl ? 
                <iframe src={`${currentPortfolioInfo.viewLnkUrl}?badge=0&autopause=0&player_id=0&autoplay=1&loop=1&muted=1`} width="600" height="340" allow="autoplay; fullscreen; picture-in-picture"></iframe>
                : <img src={NoImage} />
              }
            </MobileVideoFrame>
            <InfoWrapper>
              <SubTitle>
                <div>{currentPortfolioInfo?.ptfoNm}</div>
                <SubDescription>
                {currentPortfolioInfo?.ptfoDesc}
                </SubDescription>
              </SubTitle>
              <RowWrapper>
                <Row>
                  <ContentTitle>클라이언트</ContentTitle>
                  <ContentData>{currentPortfolioInfo?.clntNm}</ContentData>
                </Row>
                <Row>
                  <ContentTitle>제작사</ContentTitle>
                  <ContentData>{currentPortfolioInfo?.prdnStdoNm}</ContentData>
                </Row>
                <Row>
                  <ContentTitle>제작 기간</ContentTitle>
                  <ContentData className='bold'>{currentPortfolioInfo?.prdnPerd || "-"}</ContentData>
                </Row>
                <Row>
                  <ContentTitle>적정 제작비</ContentTitle>
                  <ContentData className='bold'>{currentPortfolioInfo?.prdnCost}</ContentData>
                </Row>
              </RowWrapper>
            </InfoWrapper>
          </PortfolioView>
          <ButtonWrapper>
            { buttonList.map((item) => {
              return (
                <Button 
                  active={currentMethod === item.methodName} 
                  key={item.methodName} 
                  onClick={() => clickButton(item.methodName)}
                >
                  {item.methodName}
                </Button>
              )
            }) }
          </ButtonWrapper>
        </PortfolioWrapper>
      </PortfolioContainer>
    </Container>
  )
}

export default Portfolio;

const Container = styled.div`
  display: flex;
  width: 100%;  
  margin: 0 auto;
  background: #F5F5F5;

` 

const PortfolioContainer = styled.div`
  width: 1088px;
  // height: 887px;
  margin: 0 auto;
  padding: 180px 0;

  @media ${({theme}) => theme.device.mobile} {
    width: 100%;
    height: auto;
    margin: 0;
    padding: 60px 16px 60px;
  }
`

const Title = styled.div`
  text-align: center;
  color: #2C2C2C;
  font-size: 40px;
  font-weight: 700;
  line-height: 48px;

  @media ${({theme}) => theme.device.mobile} {
    font-size: 24px;
    font-weight: 700;
    line-height: 28px;
  }
`

const Description = styled.div`
  color: #4B4B4B;
  margin-top: 8px;
  margin-bottom: 80px;
  text-align: center;
  font-size: 18px;
  font-weight: 200;
  line-height: 24px; /* 133.333% */
  @media ${({theme}) => theme.device.mobile} {
    display: none;
  }
`

const MobileDescription = styled.div`
  display: none;  
  @media ${({theme}) => theme.device.mobile} {
    text-align: center;
    font-size: 13px;
    font-weight: 200;
    line-height: 16px;
    margin: 5px 0 25px;
    display: block;
    padding: 0 5px;
    color: #ABABAC;
  }
`

const PortfolioWrapper = styled.div`
  display: flex;
  width: 100%;

  @media ${({theme}) => theme.device.mobile} {
    flex-direction: column;
    flex-direction: column-reverse;
  }
`

const PortfolioView = styled.div`
  display: flex;
  padding: 30px;
  border-radius: 10px;
  border: 0.25px solid #FFFFFF;
  background: #FFFFFF;
  box-shadow: 2px 2px 10px 2px rgba(0, 0, 0, 0.15);

  @media ${({theme}) => theme.device.mobile} {
    padding: 16px;
    flex-direction: column;
    justify-content: space-between;
  }
`

const VideoFrame = styled.div`
  width: 600px;
  height: 339px;
  border-radius: 6px;

  img {
    width: 100%;
  }

  @media ${({theme}) => theme.device.mobile} {
    display: none;
  }
`

const MobileVideoFrame = styled.div`
  display: none;

  @media ${({theme}) => theme.device.mobile} {
    display: block;
    position: relative; 
    padding-bottom: 56.25%;
    height: 100%;
    
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
    }

    img {
      width: 100%;
      padding: 0;
    }
  }
`

const InfoWrapper = styled.div`
  width: 248px;
  margin-left: 28px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media ${({theme}) => theme.device.mobile} {
    width: 100%;
    margin-left: 0;
    margin-top: 22px;
  }
`

const SubTitle = styled.div`
  min-height: 20px;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;

  @media ${({theme}) => theme.device.mobile} {
    min-height: auto;
    // margin-bottom: 15px;
  }
`

const SubDescription = styled.div`
  min-height: 150px;
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  margin-top: 8px;
  color: #ABABAC;

  @media ${({theme}) => theme.device.mobile} {
    min-height: auto;
    margin-bottom: 30px;
  }
`

const RowWrapper = styled.div``

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  min-height: 17px;

  .bold {
    font-weight: 800;
  }

  & + & {
    margin-top: 15px;
  }

  @media ${({theme}) => theme.device.mobile} {
    min-height: 20px;
    
    & + & {
      margin-top: 12px;
    }
  }
`

const ContentTitle = styled.div`
  color: #ABABAC;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
`

const ContentData = styled.div`
  font-size: 18px;
  font-weight: 300;
  line-height: 22px;
  
  @media ${({theme}) => theme.device.mobile} {
    font-size: 16px;
    font-weight: 300;
    line-height: 20px;
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 30px;

  @media ${({theme}) => theme.device.mobile} {
    flex-direction: row;
    flex-flow: row wrap;
    gap: 10px 11px;
    margin-left: 0;
    margin-bottom: 20px;
  }
`

const Button = styled.div`
  width: 120px;
  height: 40px;
  padding: 11px 7px;
  border-radius: 35px;
  background: ${props => props.active ? '#FE5A1D' : '#FFFFFF'};
  box-shadow: ${props => props.active ? '4px 4px 6px 1px rgba(0, 0, 0, 0.15) inset' : '0px 4px 4px 0px rgba(0, 0, 0, 0.10)'};
  color: ${props => props.active ? '#FFFFFF' : '#ABABAC'};
  text-align: center;
  font-size: 16px;
  font-weight: ${props => props.active ? 700 : 200};
  line-height: 19px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  @media ${({theme}) => theme.device.mobile} {
    width: 30%;
    height: 30px;
    padding: 7px;
    font-size: 13px;
    line-height: 16px;
  }
`